import Vue from "vue";
const { TokenService } = require("../../services/storage.service");
import ApiService from "../../services/api.service";
import VueScrollTo from "vue-scrollto";

const pageNames = {
	dashboard: ["dashboard"],
	rankTracking: ["dashboard-rank-tracking", "dashboard-rank-tracking-project"],
	insights: ["dashboard-insights", "dashboard-insights-project"],
	tasks: ["investigate"],
	alerts: ["alerts"],
	contentKeywords: [
		"content-and-keywords",
		"content-and-keywords-run",
		"content-and-keyword-search",
		"content-and-keywords-subtab",
		"content-and-keywords-stats",
	],
	dataDive: ["dashboard-data-dive", "data-dive-project"],
	users: ["users"],
};

const state = {
	loadingText: "",
	showHeader: true,
	showFooter: true,
	showingModal: false,
	logo: require("./../../assets/img/rank-caddy-logo.svg"),
	logo2: require("./../../assets/img/rank-caddy-logo2.svg"),
	logoBG: "",
	fullMenu: true,
	mobileMenu: false,
	siteName: "RankCaddy",
	globalMessage: "",
	globalMessageColour: "red",
	globalMessageMeta: {},
	dateFormat: "j M 'y",
	dateTimeFormat: "j M 'y H:i",
	projectList: [],
	projectListLoaded: false,
	projectListLoading: false,
	products: {},
	tagsDescription: "Grouping keywords by tags allows you to do things such as create alerts for all keywords using a tag.",
	analysisCredits: 0,
	reloadAnalysisCredits: true,
	showAnalysisCreditsHow: false,
	buyAnalysisCredits: false,
	analysisCreditsInfo: {},
	analysisCreditsAccess: {},
	analysisCreditsAllowed: false,
	analysisCreditsInfoLoaded: false,
	showVideos: false,
	singleVideo: false,
	userInfo: {},
	userLevels: [
		{
			id: "full",
			label: "Full access",
			description: "A user can do everything the default access allows plus add new keywords to a project",
		} /*,
		{  
			id: 'view',
			label: "View Only",
			description: "The user can only see the project area and has no add/edit/delete permissions"
		}*/,
	],
	tableSortingInfo: {},
	tableHeadingVisibility: {},
	playVideo: null,
	videoTitle: "",
	autoplayVideo: true,
	instructionalTipsStamp: new Date().getTime(),
	instructionalTipsLoading: false,
	instructionalTipsHide: false,
	videos: [
		{
			pageNames: pageNames.dashboard,
			videoId: "a64a7d950d41a27df567dafabff19f7a",
			thumb: "welcome.jpg",
			title: "Welcome to RankCaddy",
			type: "cloudflare",
			slug: "welcome",
			ignore: true,
		},
		{
			pageNames: [...pageNames.dashboard, ...pageNames.rankTracking],
			videoId: "8f7172f6f5420944d714aa5af019bb5d",
			thumb: "project-setup-rt.png",
			title: "Project Setup - Rank Tracking",
			type: "cloudflare",
			slug: "project-setup-rt",
		},
		{
			pageNames: [...pageNames.dashboard, ...pageNames.dataDive],
			videoId: "a54c5467256eecbcc24360c0131448f4",
			thumb: "project-setup-dd.png",
			title: "Project Setup - Data Dive",
			type: "cloudflare",
			slug: "project-setup-dd",
		},
		{
			pageNames: [...pageNames.dashboard, ...pageNames.rankTracking],
			thumb: "csv-upload.jpg",
			videoId: "8e9a324b24fbebfb8b400a62ce0d06ab",
			title: "CSV Import",
			type: "cloudflare",
			slug: "rank-tracking-csv-import",
		},
		{
			pageNames: pageNames.rankTracking,
			thumb: "rank-tracking.jpg",
			videoId: "b94109b2823480e0769f8333114be307",
			title: "Rank Tracking",
			type: "cloudflare",
			slug: "rank-tracking",
		},
		{
			pageNames: pageNames.dataDive,
			thumb: "data-dive.jpg",
			videoId: "595bab08b41a96b9f5f4a6106d92ef77",
			title: "Data Dive",
			type: "cloudflare",
			slug: "data-dive",
		},
		{
			pageNames: pageNames.insights,
			thumb: "insights.jpg",
			videoId: "6c3a9b91532ea6b54f47aa223a4c8af9",
			title: "Insights",
			type: "cloudflare",
			slug: "insights",
			ignore: true
		},
		{
			pageNames: pageNames.tasks,
			videoId: "e55e80ec4ffad68cfb9670e8c47ab280",
			thumb: "tasks.jpg",
			title: "Adding Tasks to Investigate",
			type: "cloudflare",
			slug: "tasks",
		},
		{
			pageNames: pageNames.alerts,
			videoId: "8f5995f4a2a44463da6285a872fdf71a",
			thumb: "alerts.jpg",
			title: "Flexible Email Alerts",
			type: "cloudflare",
			slug: "alerts",
		},
		{
			pageNames: pageNames.contentKeywords,
			thumb: "content-keywords2.jpg",
			title: "Content & Keywords",
			videoId: "d446d244a32fce0c0b081c31073964d2",
			type: "cloudflare",
			slug: "content-and-keywords",
		},
		{
			pageNames: pageNames.users,
			thumb: "users.jpg",
			videoId: "95572f487a30f79ef8834d7293bc607d",
			title: "Users",
			type: "cloudflare",
			slug: "users",
		},


		{
			pageNames: ["dashboard-project", "project-new-with-keywords"],
			videoId: "jqQkvG_f9jk",
			title: "Project Metrics",
			slug: "rank-tracking-metrics",
			ignore: true,
		},

		{
			pageNames: ["data-dive"],
			videoId: "uI4t8FTDQwQ",
			title: "Data Dive - Table",
			slug: "data-dive-table",
			ignore: true,
		},
		{
			pageNames: ["data-dive"],
			videoId: "jLzSiQ4xJ9c",
			title: "Data Dive - Tabs and Filters",
			slug: "data-dive-filters",
			ignore: true,
		},
		{
			pageNames: ["dashboard-project", "project-new-with-keywords"],
			videoId: "4eASlC-6f3U",
			title: "Ranking Table",
			slug: "rank-tracking-table",
			ignore: true,
		},
		{
			pageNames: ["dashboard-project", "project-new-with-keywords"],
			videoId: "SukTeP9h3R0",
			title: "Project Graph Overview",
			slug: "rank-tracking-graph",
			ignore: true,
		},
		{
			pageNames: ["dashboard-project", "project-new-with-keywords"],
			videoId: "N9QgDWKiXGk",
			title: "Project Filters",
			slug: "rank-tracking-filters",
			ignore: true,
		},
	],
	dashboardUpdates: [],
	dashboardUpdatesLoaded: false,
};

// getters
const getters = {};

// actions
const actions = {
	loadDashboardUpdates({ commit, state }) {
		if (state.dashboardUpdatesLoaded) return;
		ApiService.get("dashboard-updates").then(function(info) {
			commit("updateVar", { varName: "dashboardUpdatesLoaded", info: true });
			commit("updateVar", { varName: "dashboardUpdates", info: info.data.items });
		}.bind(this));
	},
	loadProjects({ commit, state }, payload) {
		if (!payload || !payload.projectListLoaded) {
			commit("updateVar", { varName: "projectListLoaded", info: false });
		}

		if ( ( !payload || !payload.force ) && ( state.projectListLoaded || state.projectListLoading ) ) return;

		commit("updateVar", { varName: "projectListLoading", info: true });

		ApiService.get(
			"projects/specific-fields/_id name device analyticsType googleAccount url averageGoalConversionRateAll90 averageTransactionsPerSession90"
		)
			.then(
				function(info) {
					commit("updateVar", { varName: "projectListLoading", info: false });
					commit("saveProjects", { type: "projectList", info: info.data.items });
					commit("updateVar", { varName: "projectListLoaded", info: true });
				}.bind(this)
			)
			.catch(function(err) {}.bind(this));
	},
	playVideo ({ commit, state }, videoSlug) {
		commit("updateVar", { varName: "playVideo", info: videoSlug });
		commit("updateVar", { varName: "singleVideo", info: true });
		commit("updateVar", { varName: "showVideos", info: true });
	}
};

// mutations
const mutations = {
	updateLoadingText(state, text) {
		if (typeof text === "boolean" && text) text = "One moment...";
		state.loadingText = !!text ? text : "";
	},
	reloadInstructionalTips(state) {
		state.instructionalTipsStamp = new Date().getTime();
	},
	playSingleVideo(state, videoSlug) {
		state.singleVideo = true;
		state.showVideos = true;
		state.videoTitle = null;
		if (typeof videoSlug === "object") {
			state.playVideo = videoSlug.slug;
			state.autoplayVideo = typeof videoSlug.autoplay === "undefined" ? true : videoSlug.autoplay;
			state.videoTitle = videoSlug.title || null;
		} else {
			state.playVideo = videoSlug;
		}
	},
	printGlobalMessage(state, info) {
		if (info === null || typeof info !== "object") return;
		if (!!info.message) VueScrollTo.scrollTo("#app", 100, { offset: 0 });
		if (typeof info.temp === "undefined") TokenService.saveGlobalMessage(info);
		state.globalMessage = info.message;
		state.globalMessageColour = info.colour || "red";
		state.globalMessageMeta = info.meta || {};
	},
	updateVar(state, { varName, info }) {
		Vue.set(state, varName, info);
	},
	tableSorting(state, { tableName, sortingInfo }) {
		Vue.set(state.tableSortingInfo, tableName, sortingInfo);

		TokenService.saveTableSorting(state.tableSortingInfo);
	},
	tableHeading(state, { tableName, sortingInfo }) {
		Vue.set(state.tableHeadingVisibility, tableName, sortingInfo);

		TokenService.saveTableHeadingVisibility(state.tableHeadingVisibility);
	},
	saveProjects(state, { type, info }) {
		Vue.set(state, type, info);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
